import $ from 'jquery'
import 'jquery-confirm'
import 'jquery-confirm/css/jquery-confirm.css'
import {NotificationToast} from "functions/NotificationToast";
import * as Turbolinks from "@hotwired/turbo";

export function CustomConfirm(formElement, text = null, actionBtn = 'Supprimer') {
    let content = 'Voulez-vous supprimer cet enregistrement ? <br> Ce processus ne peut pas être annulé.'
    if (text !== null) {
        content = text
    }
    $.confirm({
        icon: 'fa fa-question',
        title: 'Confirmation',
        content: content,
        useBootstrap: false,
        boxWidth: '500px',
        // autoClose: 'Annuler|10000',
        theme: 'modern',
        closeIcon: true,
        animation: 'scale',
        type: 'red',
        buttons: {
            btn: {
                text: actionBtn,
                btnClass: 'btn__confirm__delete',
                action: function () {
                    let url = formElement.action;
                    document.querySelector(".jconfirm-closeIcon")?.click()
                    document.querySelector('.spinner__loader')?.classList.add('active')
                    axios({
                        method: 'delete',
                        url: url,
                        responseType: 'json',
                        data: new FormData(formElement)
                    })
                        .then(function (response) {
                            let data = response.data

                            let redirect_url = data?.redirection
                            let search_params = new URL(redirect_url).search;
                            let current_search_params = window.location.search;
                            if (search_params !== current_search_params && search_params.search("tab") === -1) {
                                redirect_url += current_search_params;
                            }

                            Turbolinks.visit(redirect_url)

                            document.addEventListener("turbo:load", function () {
                                if (data !== undefined) {
                                    NotificationToast(data?.type, data?.message)
                                    setTimeout(() => { //remove data after 500ms
                                        data = undefined;
                                    }, 500);
                                }
                            })
                        }).catch(function (error) {
                        NotificationToast("error", error.message)
                        document.querySelector('.spinner__loader')?.classList.remove('active')
                    });
                    document.querySelector(".jconfirm.jconfirm-modern.jconfirm-open")?.remove()
                }
            },
            Annuler: function () {
            }
        }
    });
}

export function CustomConfirmValidation(text = null, actionBtn1 = 'OUI') {
    let content = 'Confirmez-vous vraiment votre action ? <br> Ce processus ne peut pas être annulé.'
    if (text !== null) {
        content = text
    }
    var defer = $.Deferred();
    $.confirm({
        icon: 'fa fa-question',
        title: 'Confirmation',
        content: content,
        useBootstrap: false,
        boxWidth: '500px',
        // autoClose: 'Annuler|10000',
        theme: 'modern',
        closeIcon: true,
        animation: 'scale',
        type: 'red',
        buttons: {
            btn: {
                text: actionBtn1,
                btnClass: 'btn__confirm__delete',
                action: function () {
                    defer.resolve(true); //answer
                }
            },
            Annuler: function () {
                defer.resolve(false); //answer
            }
        },
    })
    return defer.promise();

}

export function customAlert(message) {
    $.alert({
        icon: 'fa fa-exclamation-triangle',
        title: 'Alerte!',
        content: message,
        useBootstrap: false,
        boxWidth: '500px',
        theme: 'material',
        closeIcon: true,
        animation: 'scale',
        type: 'red'
    });
}


export function CustomConfirmLogout(formElement) {
    $.confirm({
        icon: 'fa fa-question',
        title: 'Confimation',
        content: 'Voulez-vous vraiment vous déconnectez de votre session utilisateur ?<br/><b class="delText"></b>',
        useBootstrap: false,
        boxWidth: '500px',
        theme: 'modern',
        closeIcon: true,
        animation: 'scale',
        type: 'red',
        buttons: {
            OUI: {
                btnClass: 'btn__confirm__delete',
                action: function () {
                    document.getElementById(formElement).submit();
                }
            },
            NON: function () {
            }
        }
    });

}
